<template>
  <div id="horaires_modifier">
    <router-link to="/horaires">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Gestion des horaires</h2>
    <!-- Problèmes -->
    <div class="card">
      <div class="card-header">
        <h5 class="title">
          Horaires problématiques
          <img class="imgicon" src="img/warning_yellow.png" />
          ({{ problemes_vacances.length + problemes_duplication.length / 2 + problemes_vide.length }})
          <button
            @click="refreshProblemes"
            class="float-right btn "
          >
            <font-awesome-icon :icon="'sync'" />
          </button>
        </h5>
      </div>
      <div class="card-body">
        <div
          v-if="(problemes_vacances.length + problemes_duplication.length / 2 + problemes_vide.length) > 0"
        >
          <div v-if="problemes_vacances.length > 0">
            Problème de vacances
            <font-awesome-icon :icon="'plane'" />&nbsp;
            <div class="mytooltip">
              <font-awesome-icon :icon="'question'" />
              <span
                class="mytooltiptext"
              >Pour les horaires ci-dessous, les employés de sont pas disponibles en raison de leurs vacances</span>
            </div>
            <button class="btn  btn-sm btn-primary ml-3" @click="setAllQSPVacances()">Tout définir en QSP</button>
            <b-pagination
              v-if="problemes_vacances.length > 0"
              class="mt-3"
              v-model="currentPageVacances"
              :total-rows="problemes_vacances.length"
              :per-page="perPageVacances"
              aria-controls="table-horaires"
              align="fill"
              :limit="15"
              size="sm"
            >
              <template v-slot:page="{ page, active }">
                <span style="color:white;" v-if="active">{{ page }}</span>
                <span v-else>{{ page }}</span>
              </template>
            </b-pagination>
            <b-table
              responsive="sm"
              :items="problemes_vacances"
              :fields="fields"
              :per-page="perPageVacances"
              :current-page="currentPageVacances"
              class="mt-3"
              id="table-vacances"
              small
              :sort-by.sync="sortByVacances"
              :sort-desc.sync="sortDescVacances"
              sort-icon-left
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :width="(field.key === 'fonction' || field.key === 'site') ? '8%' : field.key === 'id' ? '6%' : '15.6%'"
                />
              </template>
              <template v-slot:cell(id)="data">{{data.item.id}}</template>
              <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
              <template
                v-slot:cell(employe)="data"
              >{{employesById[data.item.id_employe].nom}} {{employesById[data.item.id_employe].prenom}}</template>
              <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
              <template v-slot:cell(fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
              <template v-slot:cell(seances)="data">
                <seances :item="data.item" />
              </template>
              <template v-slot:cell(rem)="data">{{data.item.remarque}}</template>
              <template v-slot:cell(corr)="data">
                <router-link
                  style="color:black"
                  :to="`/horaires/modification/${data.item.id}`"
                  class="btn btn-warning btn-sm"
                >
                  Corriger
                  <font-awesome-icon :icon="'pen'" />
                </router-link>
                <button class="btn btn-primary btn-sm" @click="setQSPVacances(data.item)">Définir en QSP</button>
              </template>
            </b-table>
          </div>
          <div v-if="problemes_vide.length > 0">
            Horaire(s) vide(s)
            <font-awesome-icon :icon="'calendar'" />&nbsp;
            <div class="mytooltip">
              <font-awesome-icon :icon="'question'" />
              <span class="mytooltiptext">Ces horaires ne sont liés à aucune séance (10h, 14h, etc)</span>
            </div>
            <b-pagination
              v-if="problemes_vide.length > 0"
              class="mt-3"
              v-model="currentPageVide"
              :total-rows="problemes_vide.length"
              :per-page="perPageVide"
              aria-controls="table-vide"
              align="fill"
              :limit="15"
              size="sm"
            >
              <template v-slot:page="{ page, active }">
                <span style="color:white;" v-if="active">{{ page }}</span>
                <span v-else>{{ page }}</span>
              </template>
            </b-pagination>
            <b-table
              responsive="sm"
              :items="problemes_vide"
              :fields="fields"
              :per-page="perPageVide"
              :current-page="currentPageVide"
              class="mt-3"
              id="table-vide"
              small
              :sort-by.sync="sortByVide"
              :sort-desc.sync="sortDescVide"
              sort-icon-left
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :width="(field.key === 'fonction' || field.key === 'site') ? '8%' : field.key === 'id' ? '6%' : '15.6%'"
                />
              </template>
              <template v-slot:cell(id)="data">{{data.item.id}}</template>
              <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
              <template
                v-slot:cell(employe)="data"
              >{{employesById[data.item.id_employe].nom}} {{employesById[data.item.id_employe].prenom}}</template>
              <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
              <template v-slot:cell(fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
              <template v-slot:cell(seances)="data">
                <seances :item="data.item" />
              </template>
              <template v-slot:cell(rem)="data">{{data.item.remarque}}</template>
              <template v-slot:cell(corr)="data">
                <router-link
                  style="color:black"
                  :to="`/horaires/modification/${data.item.id}`"
                  class="btn btn-warning btn-sm"
                >
                  Corriger
                  <font-awesome-icon :icon="'pen'" />
                </router-link>
              </template>
            </b-table>
          </div>
          <div v-if="problemes_duplication.length > 0">
            Problème de duplication
            <font-awesome-icon :icon="'copy'" />&nbsp;
            <div class="mytooltip">
              <font-awesome-icon :icon="'question'" />
              <span
                class="mytooltiptext"
              >Pour les horaires ci-dessous, les employés prévu sont demandés pour deux sites / fonctions le même jour et pour les même horaires</span>
            </div>
            <b-pagination
              v-if="problemes_duplication.length > 0"
              class="mt-3"
              v-model="currentPageDuplication"
              :total-rows="problemes_duplication.length"
              :per-page="perPageDuplication"
              aria-controls="table-duplication"
              align="fill"
              :limit="15"
              size="sm"
            >
              <template v-slot:page="{ page, active }">
                <span style="color:white;" v-if="active">{{ page }}</span>
                <span v-else>{{ page }}</span>
              </template>
            </b-pagination>
            <b-table
              responsive="sm"
              :items="problemes_duplication"
              :fields="fields"
              :per-page="perPageDuplication"
              :current-page="currentPageDuplication"
              class="mt-3"
              id="table-duplication"
              small
              :sort-by.sync="sortByDuplication"
              :sort-desc.sync="sortDescDuplication"
              sort-icon-left
            >
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :width="(field.key === 'fonction' || field.key === 'site') ? '8%' : field.key === 'id' ? '6%' : '15.6%'"
                />
              </template>
              <template v-slot:cell(id)="data">{{data.item.id}}</template>
              <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
              <template
                v-slot:cell(employe)="data"
              >{{employesById[data.item.id_employe].nom}} {{employesById[data.item.id_employe].prenom}}</template>
              <template v-slot:cell(site)="data">{{sitesById[data.item.id_site].nom}}</template>
              <template v-slot:cell(fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
              <template v-slot:cell(seances)="data">
                <seances :item="data.item" />
              </template>
              <template v-slot:cell(rem)="data">{{data.item.remarque}}</template>
              <template v-slot:cell(corr)="data">
                <router-link
                  style="color:black"
                  :to="`/horaires/modification/${data.item.id}`"
                  class="btn btn-warning btn-sm"
                >
                  Corriger
                  <font-awesome-icon :icon="'pen'" />
                </router-link>
              </template>
            </b-table>
          </div>
        </div>
        <h5 v-else>
          <font-awesome-icon :icon="'check'" color="lime" />&nbsp;Pas de problème à signaler...
        </h5>
      </div>
    </div>
    <!-- Paramètres -->
    <div class="card mt-3">
      <div class="card-header">
        <h5 class="title">
          Paramètres généraux
          <font-awesome-icon :icon="'cogs'" />
        </h5>
      </div>
      <div class="card-body">
        <table>
          <tr v-for="site of sites" :key="site.id">
            <td><label class="mr-2" :for="`datemax${site.id}`">
            Date maximale de consultation {{site.nom}} :
          </label></td>
          <td><date-picker :name="`datemax${site.id}`" format="dd DD/MM/YYYY" v-model="datemax[site.id]"></date-picker>
          <div class="mytooltip">
            <font-awesome-icon :icon="'question'" />
            <span
              class="mytooltiptext"
            >Les employés qui consulterons leurs horaires via CineStaff ne pourront pas voir le planning au delà de cette date</span>
          </div></td>
          </tr>
        </table>
        <button class="mt-2 btn btn-success btn-sm" @click="saveDatemax">Appliquer</button>
      </div>
    </div>
    <!-- Générer des horaires -->
    <div class="card mt-3">
      <div class="card-header">
        <h5 class="title">
          Générer des horaires
          <font-awesome-icon :icon="'cubes'" />
        </h5>
      </div>
      <div class="card-body">
        <div class="mt-3 form-inline">
          <label class="mr-2">Période :</label>
          <date-picker format="dd DD/MM/YYYY" type="date" range v-model="range"></date-picker>
        </div>
        <div class="mt-3 form-inline">
          <label class="mr-2" for="par">Avec le modèle</label>
          <select v-model="id_template" name="par" class="custom-select custom-select-sm">
            <option selected :value="undefined">-</option>
            <option
              v-for="template of templates"
              :key="template.id"
              :value="template.id"
            >{{template.nom}} ({{sitesById[template.id_site].nom}})</option>
          </select>
        </div>
        <button
          class="mt-3 btn btn-success btn-sm"
          @click="generate"
          :disabled="!(this.range[0] && this.range[1] && this.id_template)"
        >Générer</button>
      </div>
    </div>
    <!-- Supprimer une plage d'horaires -->
    <div class="card mt-3">
      <div class="card-header">
        <h5 class="title">
          Supprimer une plage d'horaires
          <font-awesome-icon :icon="'trash'" />
        </h5>
      </div>
      <div class="card-body">
        <div class="mt-3 col-6">
          <label class="mr-2">Période :</label>
          <date-picker format="dd DD/MM/YYYY" type="date" range v-model="range_delete"></date-picker>
        </div>
          <div class="col-6">
            <CheckBoxGroup
              v-bind:data="sites"
              name="sites"
              title="Sites"
              idprop="id"
              nameprop="nom"
              v-model="sites_delete"
            ></CheckBoxGroup>
          </div>
        <button
          class="mt-3 btn btn-danger btn-sm"
          @click="delete_range"
          :disabled="!(this.range_delete[0] && this.range_delete[1] && this.sites_delete[0])"
        >Supprimer</button>
      </div>
    </div>
    <!-- Remplacement global -->
    <div class="card mt-3">
      <div class="card-header">
        <h5 class="title">
          Remplacement global
          <font-awesome-icon :icon="'random'" />
        </h5>
      </div>
      <div class="card-body">
        <h5>
          <font-awesome-icon :icon="'cog'" />&nbsp;Paramètres :
        </h5>
        <div class="mt-3 form-inline">
          <label class="mr-2" for="remplacer">Remplacer :</label>
          <select
            v-model="id_employe_remplacer"
            name="remplacer"
            class="custom-select custom-select-sm"
          >
            <option selected :value="undefined">-</option>
            <option
              v-for="employe of employes"
              :key="employe.id"
              :value="employe.id"
            >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
          </select>
        </div>
        <div class="mt-3 form-inline">
          <label class="mr-2" for="par">Par :</label>
          <select v-model="id_employe_par" name="par" class="custom-select custom-select-sm">
            <option selected :value="undefined">-</option>
            <option value="-1">QSP</option>
            <option
              v-for="employe of employes"
              :key="employe.id"
              :value="employe.id"
            >{{employe.acronyme}} - {{employe.nom}} {{employe.prenom}}</option>
          </select>
        </div>
        <div class="mt-3 form-inline">
          <label class="mr-2">Pour la période :</label>
          <date-picker type="date" format="dd DD/MM/YYYY" range v-model="range_remplacement"></date-picker>
        </div>
        <h5 class="mt-2">
          <font-awesome-icon :icon="'filter'" />&nbsp;Filtres :
        </h5>
        <div class="mt-3 row">
          <div class="col-6">
            <CheckBoxGroup
              v-bind:data="fonctions"
              name="fonctions"
              title="Fonctions"
              idprop="id"
              nameprop="nom"
              v-model="filters.fonctions"
            ></CheckBoxGroup>
          </div>
          <div class="col-6">
            <CheckBoxGroup
              v-bind:data="sites"
              name="sites"
              title="Sites"
              idprop="id"
              nameprop="nom"
              v-model="filters.sites"
            ></CheckBoxGroup>
          </div>
        </div>
        <div class="mt-3 row">
          <div class="col-12">
            <CheckBoxGroup
              v-bind:data="heures"
              name="heures"
              title="Heures"
              idprop="id"
              nameprop="nom"
              v-model="filters.heures"
            ></CheckBoxGroup>
          </div>
        </div>
        <button class="mt-5 btn btn-success btn-sm" @click="remplacementGlobal">Appliquer</button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DateRangePicker from "vue2-daterange-picker";
import CheckBoxGroup from "../components/CheckBoxGroup";
import moment from "moment";
import api from "@/api";
import utils from "@/utils";
import Seances from "../components/Seances";
import DatePicker from "vue2-datepicker";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      moment,
      filters: { sites: [], fonctions: [], heures: [] },
      id_employe_remplacer: undefined,
      id_employe_par: undefined,
      range_remplacement: [],
      datemax: [],
      utils,
      begin: undefined,
      enddate: undefined,
      range: [],
      range_delete: [],
      sites_delete: [],
      locale: {
        separator: " - ",
        applyLabel: "Valider",
        cancelLabel: "Annuler",
        weekLabel: "S",
        customRangeLabel: "Plage personnalisée",
        daysOfWeek: ["Sa", "Di", "Lu", "Ma", "Me", "Je", "Ve"],
        monthNames: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Novembre",
          "Décembre"
        ],
        firstDay: 1,
        format: "dd DD/MM/YYYY"
      },
      heures: [],
      problemes_vacances: [],
      problemes_duplication: [],
      problemes_vide: [],
      sitesById: [],
      sites: [],
      fonctionsById: [],
      fonctions: [],
      employesById: [],
      employes: [],
      templates: [],
      id_template: undefined,
      perPageVacances: 7,
      currentPageVacances: 1,
      sortByVacances: "",
      sortDescVacances: false,
      perPageDuplication: 7,
      currentPageDuplication: 1,
      sortByDuplication: "",
      sortDescDuplication: false,
      perPageVide: 7,
      currentPageVide: 1,
      sortByVide: "",
      sortDescVide: false,
      fields: [
        { key: "id", label: "Référence", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "site", label: "Site", sortable: false },
        { key: "employe", label: "Employé", sortable: false },
        { key: "fonction", label: "Fonction", sortable: false },
        { key: "seances", label: "Séances", sortable: false },
        { key: "rem", label: "Remarque", sortable: false },
        { key: "corr", label: "Corriger", sortable: false }
      ]
    };
  },
  components: { DatePicker, DateRangePicker, CheckBoxGroup, Seances },
  async created() {
    this.$store.commit("setLoading", true);
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.heures = [
      { id: "h10", nom: "10h" },
      { id: "h14", nom: "14h" },
      { id: "h18", nom: "18h" },
      { id: "h20", nom: "20h" },
      { id: "matin", nom: "Matin" },
      { id: "apresmidi", nom: "Après-midi" }
    ];
    let dates = (await api.getDateMax()).data.datemax;
    for (let site of this.sites){
      this.datemax[site.id] = new Date(dates[site.id]);
    }
    this.templates = (await api.getTemplateList()).data.templates;
    this.refreshProblemes();
    this.$store.commit("setLoading", false);
  },
  methods: {
    setQSPVacances: async function(horaire) {
      let response = await api.setQSPVacances(horaire);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      if (response.code === 200) {
        this.refreshProblemes();
      }
    },
    setAllQSPVacances: async function() {
      this.$store.commit("setLoading", true);
      let ok = true;
      for (let horaire of this.problemes_vacances) {
        let response = await api.setQSPVacances(horaire);
        ok = ok ? response.code === 200 : false;
        if (!ok) {
          break;
        }
      }
      Toast.fire({
        type: ok ? "success" : "error",
        text: ok ? "Horaires changés en QSP" : "Une erreur est survenue"
      });
      this.refreshProblemes();
      this.$store.commit("setLoading", false);
    },
    refreshProblemes: async function() {
      let problemes = (await api.getHorairesProblemes()).data;
      this.problemes_vacances = problemes.problemes_vacances;
      this.problemes_duplication = problemes.problemes_duplication;
      this.problemes_vide = problemes.problemes_vide;
    },
    remplacementGlobal: async function() {
      if (
        this.id_employe_remplacer &&
        this.id_employe_par &&
        this.range_remplacement[0] &&
        this.range_remplacement[1]
      ) {
        let reponse = await api.remplacementGlobal(
          this.id_employe_remplacer,
          this.id_employe_par,
          moment(this.range_remplacement[0]).utc(true).toDate(),
          moment(this.range_remplacement[1]).utc(true).toDate(),
          this.filters
        );
        Swal.fire({
          type: reponse.code === 200 ? "success" : "error",
          text: reponse.message
        });
      } else {
        Swal.fire({
          type: "warning",
          text: "Merci de remplir tous les paramètres"
        });
      }
    },
    saveDatemax: async function() {
      let response = await api.setDatemax(this.datemax);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
    },
    delete_range: function() {
      if (this.range_delete[0] && this.range_delete[1] && this.sites_delete[0]){
         Swal.fire({
          title: `Supprimer les horaires du ${moment(
            this.range_delete[0]
          ).format("dd DD/MM/YYYY")} au ${moment(this.range_delete[1]).format(
            "dd DD/MM/YYYY"
          )} ?`,
          text:
            "Les horaires seront définitivement supprimés.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui",
          cancelButtonText: "Non"
        }).then(async result => {
          if (result.value) {
            let range = this.range_delete;
            let sites = this.sites_delete;
            range[0] = moment(range[0]).utc(true).toDate();
            range[1] = moment(range[1]).utc(true).toDate();
            Swal.fire({
              title: "Suppression des horaires...",
              onBeforeOpen() {
                Swal.showLoading();
              },
              onAfterClose() {
                Swal.hideLoading();
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              async onOpen() {
                let response = await api.deleteHoraires(
                  moment(range[0]).utc(true).toDate(),
                  moment(range[1]).utc(true).toDate(),
                  sites
                );
                Swal.close();
                Toast.fire({
                  type: response.code === 200 ? "success" : "error",
                  text: response.message
                });
              }
            });
          }
        });
      }
    },
    generate: function() {
      if (this.range[0] && this.range[1] && this.id_template) {
        Swal.fire({
          title: `Générer automatiquement les horaires du ${moment(
            this.range[0]
          ).format("dd DD/MM/YYYY")} au ${moment(this.range[1]).format(
            "dd DD/MM/YYYY"
          )} ?`,
          text:
            "Attention: si des horaires sont déjà existants dans cette periodes, ils seront remplacés.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui",
          cancelButtonText: "Non"
        }).then(async result => {
          if (result.value) {
            let id_template = this.id_template;
            let range = this.range;
            Swal.fire({
              title: "Création des horaires...",
              onBeforeOpen() {
                Swal.showLoading();
              },
              onAfterClose() {
                Swal.hideLoading();
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              async onOpen() {
                let response = await api.generateHoraires(
                  id_template,
                  moment(range[0]).utc(true).toDate(),
                  moment(range[1]).utc(true).toDate()
                );
                Swal.close();
                Toast.fire({
                  type: response.code === 200 ? "success" : "error",
                  text: response.message
                });
              }
            });
          }
        });
      }
    }
  }
};
</script>